import { Button, Pagination, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useScrollUpPage } from 'shared/hooks';
import { TColumns, TUnionTableData } from 'shared/types/types';
import { RowSelectionType } from 'antd/lib/table/interface';
import SearchComponent from 'shared/components/search/news-faq';
import { SearchKeysNews } from 'shared/enums/news';
import StringFormItem from 'shared/components/search/news-faq/stringFormItem/StringFormItem';
import NumberFormItem from 'shared/components/search/news-faq/numberFormItem/NumberFormItem';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'app/store';
import { dayOffSelectedActions } from 'entities/dayOff/dayOffSelection';
import { TPreparedDayOffPublicated } from 'shared/types/dayoff.types';
import style from './index.module.scss';

type TProps = {
  dataSource: TUnionTableData;
  columns: TColumns;
  currentPage: number;
  currentSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setCurrentSize: React.Dispatch<React.SetStateAction<number>>;
  total: number | undefined;
  rowSelectionType?: RowSelectionType;
  onSearch?: (data: string, key: SearchKeysNews) => void;
  isCancel?: boolean;
};

export const TableInProgressDayOff = ({
  dataSource,
  columns,
  currentPage,
  setCurrentSize,
  setCurrentPage,
  currentSize,
  total,
  rowSelectionType = 'checkbox',
  onSearch,
  isCancel = false,
}: TProps) => {
  const [selectRows, setSelectRows] = useState<TUnionTableData>([]);
  const navigate = useNavigate();
  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };
  const dispatch = useAppDispatch();

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: TUnionTableData) => {
      setSelectRows(selectedRows);
      dispatch(dayOffSelectedActions.set(selectedRows as unknown as TPreparedDayOffPublicated[]));
    },
  };

  const getCheckboxProps = (record: TUnionTableData[number]) => ({});

  useScrollUpPage(currentPage);

  useEffect(() => {
    const key = dataSource.find(item => item?.key === selectRows[0]?.key);
    if (!key) {
      setSelectRows([]);
    }
  }, [dataSource]);

  const onclickToRow = (id: number) => {
    if (isCancel) {
      navigate(`/cancelDayOff/cancelDayOffUser/${id}`);
    } else {
      navigate(`/dayOffUser/${id}`);
    }
  };

  return (
    <div className={style.wrapper}>
      <SearchComponent
        selectOptions={{
          [SearchKeysNews.SEARCH_NAME]: {
            name: SearchKeysNews.SEARCH_NAME,
            alias: 'ФИО',
            node: StringFormItem({
              name: SearchKeysNews.SEARCH_NAME,
              placeholder: 'Введите ФИО',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.SEARCH_NAME);
              },
            }),
          },
          [SearchKeysNews.SEARCH_ID]: {
            name: SearchKeysNews.SEARCH_ID,
            alias: 'Номер заявки',
            node: NumberFormItem({
              name: SearchKeysNews.SEARCH_ID,
              placeholder: 'Введите номер заявки',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.SEARCH_ID);
              },
            }),
          },
          [SearchKeysNews.PERSONNEL_NUMBER]: {
            name: SearchKeysNews.PERSONNEL_NUMBER,
            alias: 'ТН',
            node: StringFormItem({
              name: SearchKeysNews.PERSONNEL_NUMBER,
              placeholder: 'Введите ТН',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.PERSONNEL_NUMBER);
              },
            }),
          },
          [SearchKeysNews.POSITION_NAME]: {
            name: SearchKeysNews.POSITION_NAME,
            alias: 'Должность',
            node: StringFormItem({
              name: SearchKeysNews.POSITION_NAME,
              placeholder: 'Введите должность',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.POSITION_NAME);
              },
            }),
          },
          [SearchKeysNews.DIVISION_NAME]: {
            name: SearchKeysNews.DIVISION_NAME,
            alias: 'Подразделение',
            node: StringFormItem({
              name: SearchKeysNews.DIVISION_NAME,
              placeholder: 'Введите подразделение',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.DIVISION_NAME);
              },
            }),
          },
        }}
      />

      <Table
        scroll={{ x: true }}
        rowSelection={{
          selectedRowKeys: selectRows.map(item => item.id),
          type: rowSelectionType,
          getCheckboxProps,
          ...rowSelection,
        }}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        bordered
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              onclickToRow(+record.id);
            },
          };
        }}
        rowClassName="row"
      />
      <div className={style.paginationWrap}>
        <Pagination
          showSizeChanger
          defaultCurrent={currentSize}
          current={currentPage}
          pageSize={currentSize}
          total={total}
          onChange={(value: number, pageSize: number) => handlePagination(value, pageSize)}
        />
      </div>
    </div>
  );
};
